export default __webpack_public_path__ + "static/jennifer-bitmoji-22314cb9ba2a04bd7014aef478318911.png";